// components/HeroSection.jsx
import FadeIn from "./FadeInOnScroll";
import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="bg-gradient-to-b from-purple-50 via-purple-100 to-purple-200 py-24 px-4 -mt-40 md:mt-0">
      <FadeIn>
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between bg-white/70 border border-purple-200 rounded-2xl p-6 md:p-10 relative overflow-visible shadow-glass">
          {/* 左侧内容 */}
          <div className="w-full md:w-2/3 z-10 text-center md:text-left">
            <h1 className="text-3xl md:text-4xl font-bold text-purple-900 mb-4 leading-tight">
              Ready to begin your business transformation?
            </h1>
            <p className="text-base md:text-lg text-purple-700/80 mb-6">
              AI Nova stands ready, not only as a technology provider, <br /> but as a
              builder of ecosystems and a partner in inclusive progress
            </p>
            <div className="flex justify-center md:justify-start">
              <Link
                to="/contact"
                className="cursor-pointer tracking-widest bg-purple-700 border border-purple-700 text-white font-semibold py-2 px-6 sm:px-8 md:py-3 md:px-10 rounded-md transition-all duration-300 ease-in-out hover:bg-purple-600 hover:border-purple-500 hover:shadow-lg hover:shadow-purple-300/60"
              >
                Contact Us
              </Link>
            </div>
          </div>

          {/* 右侧人物图片 */}
          <div className="w-full md:w-1/3 mt-10 md:mt-0 relative z-20 flex justify-center items-end">
            <div className="relative w-[220px] sm:w-[260px] md:w-[320px] lg:w-[400px] -mb-20">
              {/* 渐变遮罩 */}
              <div
                className="absolute bottom-0 left-0 w-full h-24 bg-gradient-to-t from-white/80 to-transparent z-30 pointer-events-none rounded-b-2xl"
                style={{ transform: "translateY(-60px)" }}
              ></div>

              {/* 人物图片（可以用 next/image 也可以保持 img） */}
              {/* <img
                src="/businessManNew.png"
                alt="Business Person"
                width={400}
                height={500}
                className="object-contain relative z-20"
                style={{ transform: "translateY(-50px)" }}
              /> */}
            </div>
          </div>

          {/* 背景装饰（仅在 md 以上显示） */}
          <div className="hidden md:block absolute right-10 top-10 w-80 h-80 border-2 border-purple-300 rounded-3xl rotate-45 opacity-30 z-0"></div>
          <div className="hidden md:block absolute right-10 top-10 w-64 h-64 bg-gradient-to-tr from-purple-400 to-pink-400 rounded-3xl rotate-45 opacity-30 z-0"></div>
          <div className="hidden md:block absolute left-0 bottom-0 w-80 h-80 border-2 border-purple-300 rounded-3xl rotate-45 opacity-20 z-0"></div>
          <div className="hidden md:block absolute left-12 bottom-2 w-80 h-80 border-2 border-purple-200 rounded-3xl rotate-45 opacity-20 z-0"></div>
        </div>
      </FadeIn>
    </section>
  );
}
